import React from 'react';
import EnglishLetterPronunciation from "../components/game/EnglishLetterPronunciation/EnglishLetterPronunciation";
import EnglishLetterHidden from "../components/game/EnglishLetterHidden/EnglishLetterHidden";

export const alphabet = ["english","ukraine"];
export const languages = [
  { language: "english", code: "US" },
  { language: "ukraine", code: "UA" },
  { language: "french", code: "FR" },
];

export const GamesConfig = {
  // eslint-disable-next-line
  ['english-letter-pronunciation'] : <EnglishLetterPronunciation/>,
    // eslint-disable-next-line
  ['english-letter-hidden'] : <EnglishLetterHidden/>
}

export const chooseLenguageData = {
  english: ["english", "ukraine"],
  ukraine: ["англійська","українська"],
};

export const languageTitle = {
  english: "English Language",
  ukraine: "Українська мова",
};
export const chooseLenguageAlphabet = {
  english: "Alphabet",
  ukraine: "Алфавіт",
};
export const chooseDrawerNumber = {
  english: "Number",
  ukraine: "Числа",
};
export const chooseDrawerSetting = {
  english: "Setting",
  ukraine: "Налаштування",
};
export const chooseDrawerContacts = {
  english: "Contacts",
  ukraine: "Контакти",
};
